import { ref } from "vue";
import { useStore } from "@/store";
const store = useStore();
import { GeneralActionTypes } from "@/store/modules/general/action-types";
const activeRowModal: any = ref({ data: null });
const data = {
  readyToUseFilters: {},
  filter: {
    ignoreSaveFilter: true,
    hideFilter: true,
    title: "userActivity",
    pageName: "auditPageFilter",
    genre: "auditPageFilter",
    filters: [
      {
        title: "Time Range",
        type: "date",
        param: "range",
        apiEquivalent: "range",
        hidden: true,
        vmodel: null,
      },
    ],
  },
  header: {
    navigation: [
      {
        title: "userActivity",
        url: "user-activity",
      },
    ],
  },
  component: {
    type: "ag-table",
    options: {
      id: "exportable-table",
      dateFilter: true,
      columns: [
        {
          label: "eventDate",
          field: "auditDate",
          excelField: "auditDate",
          // sortable: true,
        },
        {
          label: "username",
          field: "auditUserName",
          // sortable: true,
        },
        {
          label: "auditEventCategory",
          field: "auditAction",
          // sortable: true,
        },
        {
          label: "subject",
          field: "tableName",
          excelField: "tableName",
        },
        {
          label: "activityScope",
          field: "siteName",
          excelField: "siteId",
          sortable: false,
          display: function (row: any) {
            let text = '';
            if(row.siteName) {
              text = text + `<p class="mb-2"><strong>Site : </strong> ${row.siteName}</p>`
            }
            if(row.groupName) {
              text = text + `<p class="mb-2"><strong>Group : </strong> ${row.groupName}</p>`
            }
            return `<div class="d-flex align-items-start flex-column">${text}</div>`;
          },
        },
        // {
        //   label: "groupname",
        //   field: "groupName",
        //   excelField: "groupId",
        //   sortable: true,
        // },
        {
          label: "",
          components: [
            {
              label: "Details",
              component: "tableExpandComponent",
            },
          ],
        },
      ],
      rows: [],
      total: 10000,
      sortable: {
        order: "ReportedEventDate",
        sort: "desc",
      },
      page: 1,
      pageSize: 5,
      isLoading: false,
      fetchTable: (options: any) => {
        const filters = data.readyToUseFilters; //data.filter
        const body = { filters, options };
        store.dispatch(GeneralActionTypes.GET_AUDITS, body);
      },
    },
  },
  modals: [
    {
      id: "exampleModalCenter",
      action: {
        label: "OK",
        function: function (arg: any) {
          // alert(JSON.stringify(arg));
        },
      },
      cancel: {
        label: "Close",
      },
      active: 0,
      items: [
        {
          title: "auditEvent",
          component: "ag-audit-detail",
          options: { activeRowModal },
        },
      ],
    },
  ],
};

export default data;
